"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }// src/core/HttpClient.ts
var _crossfetch = require('cross-fetch'); var _crossfetch2 = _interopRequireDefault(_crossfetch);
var _httperrors = require('http-errors'); var _httperrors2 = _interopRequireDefault(_httperrors);
var _defaultErrorHandler = require('../utils/defaultErrorHandler'); var _defaultErrorHandler2 = _interopRequireDefault(_defaultErrorHandler);
var _defaultResponseHandler = require('../utils/defaultResponseHandler'); var _defaultResponseHandler2 = _interopRequireDefault(_defaultResponseHandler);
var _defaultPreflightHandler = require('../utils/defaultPreflightHandler'); var _defaultPreflightHandler2 = _interopRequireDefault(_defaultPreflightHandler);
var _buildUrl = require('../utils/buildUrl'); var _buildUrl2 = _interopRequireDefault(_buildUrl);
var _browserFetch = require('./browserFetch'); var _browserFetch2 = _interopRequireDefault(_browserFetch);
var HttpClient = class {
  constructor(opts = {}) {
    this.baseUrl = opts.baseUrl;
    this.fetchImpl = _nullishCoalesce(_nullishCoalesce(opts.fetchImpl, () => ( _browserFetch2.default)), () => ( _crossfetch2.default));
    this.logger = opts.logger;
    this.errorHandler = _nullishCoalesce(opts.errorHandler, () => ( _defaultErrorHandler2.default));
    this.responseHandler = _nullishCoalesce(opts.responseHandler, () => ( _defaultResponseHandler2.default));
    this.preflightHandler = _nullishCoalesce(opts.preflightHandler, () => ( _defaultPreflightHandler2.default));
  }
  log(...args) {
    _optionalChain([this, 'access', _ => _.logger, 'optionalAccess', _2 => _2.info, 'call', _3 => _3(...args)]);
  }
  async makeRequest(url, opts) {
    try {
      const fetchUrl = _buildUrl2.default.call(void 0, url, this.baseUrl, opts.searchParams);
      const preflightArgs = {
        url: fetchUrl,
        options: opts
      };
      await this.preflightHandler(preflightArgs);
      this.log(`Outgoing ${opts.method} request: ${preflightArgs.url}`);
      const response = await this.fetchImpl(preflightArgs.url, preflightArgs.options).catch(
        async (err) => {
          const { handleOAuthFlow, body, ...httpOptions } = preflightArgs.options;
          if (!handleOAuthFlow) {
            throw err;
          }
          const danceOpts = {
            ...httpOptions,
            mode: "no-cors",
            method: "GET",
            credentials: "include"
          };
          this.log(`Making no-cors request: ${preflightArgs.url}`);
          await this.fetchImpl(preflightArgs.url, danceOpts);
          this.log(`no-cors request succeeded, making original request: ${preflightArgs.url}`);
          return await this.fetchImpl(preflightArgs.url, preflightArgs.options);
        }
      );
      if (response.status >= 400) {
        throw _httperrors2.default.call(void 0, response.status, response.statusText, { response });
      }
      return await this.responseHandler(response);
    } catch (err) {
      return await this.errorHandler(err);
    }
  }
  async get(url, opts = {}) {
    return await this.makeRequest(url, {
      ...opts,
      method: "GET"
    });
  }
  async post(url, opts) {
    return await this.makeRequest(url, {
      ...opts,
      method: "POST"
    });
  }
  async put(url, opts) {
    return await this.makeRequest(url, {
      ...opts,
      method: "PUT"
    });
  }
  async del(url, opts) {
    return await this.makeRequest(url, {
      ...opts,
      method: "DELETE"
    });
  }
  async patch(url, opts) {
    return await this.makeRequest(url, {
      ...opts,
      method: "PATCH"
    });
  }
};


exports.default = HttpClient;

module.exports = exports.default;
